<template>
  <svg width="44"
       height="32"
       viewBox="0 0 44 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26 10H2M18 18H2M10 26H2M34 2H2M36 10V30M36 30L42 24M36 30L30 24"
      :stroke="color"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#07455D"
    }
  }
}
</script>
